import { useState } from "react";
import { faqs } from "@/mocks/qxian";

export default function Faq() {
  const [openIdx, setOpenIdx] = useState(0);

  return (
    <section id="faq" className="w-full bg-background-50 scroll-mt-16 py-12 md:py-16">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="grid gap-8 lg:grid-cols-[minmax(0,360px)_1fr]">
          <div>
            <span className="inline-flex items-center gap-2 text-xs font-semibold text-primary-600">
              <i className="ri-question-line"></i>
              常被问到的
            </span>
            <h2 className="mt-3 font-heading text-2xl md:text-4xl font-black text-foreground-950">常见问题</h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              关于吃瓜前线的更新频率、事件对齐方式与信息可信度，这里统一说明，帮你用得更顺手。
            </p>
            <a
              href="#about"
              className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 text-background-50 px-5 py-2.5 text-sm hover:bg-primary-600 transition-colors"
            >
              还有问题？
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>

          <div className="space-y-3">
            {faqs.map((f, i) => {
              const open = openIdx === i;
              return (
                <div
                  key={f.q}
                  className={"rounded-xl border bg-background-100/50 overflow-hidden transition-colors " + (open ? "border-primary-200" : "border-background-200")}
                >
                  <button
                    onClick={() => setOpenIdx(open ? -1 : i)}
                    className="w-full flex items-center justify-between gap-3 px-4 md:px-5 py-4 text-left cursor-pointer"
                    aria-expanded={open}
                  >
                    <h3 className="text-sm md:text-base font-semibold text-foreground-900">{f.q}</h3>
                    <span
                      className={"shrink-0 w-7 h-7 flex items-center justify-center rounded-full text-sm transition-transform " + (open ? "rotate-180 bg-primary-500 text-background-50" : "bg-background-50 text-foreground-500 border border-background-200")}
                    >
                      <i className="ri-arrow-down-s-line text-lg"></i>
                    </span>
                  </button>
                  {open && (
                    <p className="px-4 md:px-5 pb-4 text-sm leading-relaxed text-foreground-600 fade-up">{f.a}</p>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}